import { render, staticRenderFns } from "./VariableAmbit.vue?vue&type=template&id=29e6c10a&"
import script from "./VariableAmbit.vue?vue&type=script&lang=js&"
export * from "./VariableAmbit.vue?vue&type=script&lang=js&"
import style0 from "./VariableAmbit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports